import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { get, isEqual } from 'lodash'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { push, goBack } from 'connected-react-router'
import { Prompt } from 'react-router-dom'

import { modal } from 'redux/modules/app'
import withWizardContext from 'helpers/decorators/Wizard/WithWizardContext'
import configFile from 'config'

function decorator(config = {}) {
  return ComposedComponent => {
    @withWizardContext()
    @injectIntl
    @reduxForm({
      ...config,
      destroyOnUnmount:
        config.destroyOnUnmount === undefined ? true : config.destroyOnUnmount
    })
    @connect(
      state => ({
        values: state.form[config.form] && state.form[config.form].values,
        errors: state.form[config.form] && state.form[config.form].syncErrors,
        modalObj: state.app.modal
      }),
      { modal, push, goBack }
    )
    class Form extends Component {
      static propTypes = {
        pristine: PropTypes.bool.isRequired,
        submitSucceeded: PropTypes.bool.isRequired,
        modalObj: PropTypes.object.isRequired,
        route: PropTypes.object,
        modal: PropTypes.func.isRequired,
        links: PropTypes.object,
        push: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        goBack: PropTypes.func.isRequired,
        initialize: PropTypes.func.isRequired,
        intl: PropTypes.object
      }

      componentDidMount() {
        this.handleFormInitialize(this.handleGetInitialProps(this.props))
      }

      componentWillReceiveProps = nextProps => {
        if (
          !isEqual(
            get(this.props, config.dataKey),
            get(nextProps, config.dataKey)
          )
        ) {
          this.handleFormInitialize(this.handleGetInitialProps(nextProps))
        }
      }

      handleFormInitialize = data => {
        if (config.dataKey) {
          this.props.initialize(data)
        }
      }

      handleGetInitialProps = props =>
        config.initialPropsMapper
          ? config.initialPropsMapper(get(props, config.dataKey))
          : get(props, config.dataKey)

      handlePromptClosing = nextLoc => {
        const { pristine, submitSucceeded, links } = this.props

        if (config.disableHook)
          return false

        if ((submitSucceeded || pristine) && !config.multipage) {
          return true
        }

        if (config.multipage && links) {
          const currentItem = links.findEntry(
            item => item.id === this.props.route.activeId
          )

          const isAllowed =
            currentItem &&
            currentItem[1].allowedPaths.some(item => {
              return item.includes('*')
                ? nextLoc.pathname.startsWith(`${configFile.publicPath}${item.replace('*', '')}`)
                : nextLoc.pathname === `${configFile.publicPath}${item}` })

          return !isAllowed
        }

        return false
      }

      handleSubmitCustom = submitHandler => {
        return e => {
          if (config.stopPropagation) {
            e.stopPropagation()
          }

          return this.props.handleSubmit(submitHandler)(e)
        }
      }

      render() {
        const { intl } = this.props

        return (
          <div style={{ width: '100%', height: '100%' }}>
            <ComposedComponent {...this.props}
                               handleSubmit={this.handleSubmitCustom}
            />
            <Prompt
              message={nextLoc =>
                this.handlePromptClosing(nextLoc)
                ? intl.formatMessage({
                  defaultMessage:
                    "Your changes haven't been saved. Data will be lost.",
                  id: 'label.your_changes_havent_been_saved'
                })
                : true
              }
            />
          </div>
        )
      }
    }
    return Form
  }
}

export default decorator
